
import { Component, Prop, Vue } from "vue-property-decorator";

import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import IconButton from "@/components/UI/IconButton.vue";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";

import { AIPreset, PromptSettings } from "@/lib/ai/types";
import NiceButton from "@/components/UI/NiceButton.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import Repeater from "../Reusable/CustomInputs/Repeater/Repeater.vue";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: {
    TextInput,
    NumberInput,
    IconButton,
    TopBarSection,
    NiceButton,
    DropdownInput,
    Repeater
  }
})
export default class AISettings extends Vue {
  @Prop()
  settings!: PromptSettings;

  @Prop()
  loading!: boolean;

  updateField(
    field: "businessName" | "qualifiers" | "businessDescription",
    value: string
  ) {
    const newSettings = defensiveCopy(this.settings);
    newSettings[field] = value;
    this.$emit("input", newSettings);
  }

  updatePresets(presets: AIPreset[]) {
    const newSettings = defensiveCopy(this.settings);
    newSettings.presets = presets;
    this.$emit("input", newSettings);
  }

  updatePreset(property: "name" | "prompt", value: string, index: number) {
    const newSettings = defensiveCopy(this.settings);
    const presets = newSettings.presets || [];
    presets[index][property] = value;
    newSettings.presets = presets;

    this.$emit("input", newSettings);
  }
}
